import { CommonModule, NgIf } from '@angular/common';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgPipesModule } from 'ngx-pipes';
import { AuthService } from 'src/app/@auth/auth.service';
import { CluFeSnackbarService } from 'src/app/@clu-fe/apps/@services/clufe-snackbar.service';
import { AuthSessionDto } from 'src/app/app.models';
import { MaterialModule } from 'src/app/material.module';

@Component({
    selector     : 'md-about',
    templateUrl  : './md-about.component.html',
    styleUrls: ['./md-about.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, TranslateModule, TablerIconsModule, NgPipesModule, CommonModule],
    providers : [CluFeSnackbarService]
})
export class MdAboutComponent implements OnInit 
{
    authSessionDto: AuthSessionDto;
    constructor(@Inject(MAT_DIALOG_DATA) private dataE: any, public matDialogRef: MatDialogRef<MdAboutComponent>, private authService: AuthService, private _snackbarService : CluFeSnackbarService, private _matDialog : MatDialog){
        this.authSessionDto = authService.authenticatedSession$.value!;
    }
    
    ngOnInit(): void {
        this.matDialogRef.keydownEvents().subscribe(event => { if (event.key === "Escape") { this.matDialogRef.close(); } });
    }

}
